<template>
  <PSOrgOpenAnnular />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
